<template>
  <!-- Content -->
  <d-row>
    <d-col lg="8" xl="9">
      <d-card class="card-small mb-4">
        <!-- Card Header -->
        <d-card-header class="border-bottom">
          <d-row class="align-items-center">
            <d-col cols="12" lg="6">
              <h6 class="m-0">Dados cadastrais</h6>
            </d-col>
          </d-row>
        </d-card-header>

        <d-list-group flush>
          <d-list-group-item class="p-3">
            <d-row>
              <d-col>
                <puzzle-form ref="puzzleForm" />
                <div class="w-100 text-center my-2" v-if="!puzzle.id">
                  <span>Dê duplo clique nas células para marcar como pergunta</span>
                </div>
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
    <!-- Sidebar Widgets -->
    <d-col lg="4" xl="3" sm="12">
      <d-card class="card-small mb-3">
        <d-card-header class="border-bottom">
          <h6 class="m-0">Publicação</h6>
        </d-card-header>

        <d-card-body class="px-0">
          <d-list-group flush>
            <d-list-group-item class="px-3 py-0">
              <div class="pb-1">Criado em: {{ puzzle.f_created }}</div>
              <div class="pb-1">Atualizado em: {{ puzzle.f_updated }}</div>
              <div class="d-flex flex-column" v-if="puzzle.id">
                <span class="print-link mb-2" @click="print('answers')">
                  Imprimir Respostas
                </span>
                <span class="print-link" @click="print('questions')">
                  Imprimir Perguntas
                </span>
              </div>
            </d-list-group-item>
            <d-list-group-item class="p-3">
              <d-button
                @click="openImportModal"
                class="btn-outline-light border btn-block"
              >
                <i class="material-icons">cloud_upload</i> Importar Arquivo
              </d-button>
              <d-button
                @click="openSaveTemplateModal"
                class="btn-outline-light border btn-block"
              >
                Salvar como Template
              </d-button>
              <d-button
                @click.prevent="generateNewFromCurrentTemplate()"
                class="btn-info btn-block mt-2"
                :disabled="isGenerating || !hasAnyLetter"
              >
                Salvar e Gerar novo Jogo
              </d-button>
              <p
                v-if="!hasAnyLetter"
                class="text-muted mb-0 small mb-2"
              >
                O grid está sem palavras. Insira novas para habilitar.
              </p>
              <d-button
                @click.prevent="fillCrossword()"
                class="btn-dark btn-block"
                :disabled="hasNoQuestions"
              >
                Inserir Palavras
              </d-button>
              <p
                v-if="hasNoQuestions"
                class="text-muted mb-0 small"
              >
                Sinalize pelo menos uma pergunta no grid.
              </p>
            </d-list-group-item>
          </d-list-group>
        </d-card-body>

        <d-card-footer
          class="border-top d-flex flex-column flex-xl-row justify-content-around"
        >
          <d-button
            @click="save"
            type="button"
            class="btn-primary mb-3 mb-xl-0 col-xl-5"
          >
            Salvar
          </d-button>
          <router-link
            class="btn-secondary btn text-white col-xl-5"
            :to="{ name: 'admin-crossword-list', params: { page: 1 } }"
          >
            Cancelar
          </router-link>
        </d-card-footer>
      </d-card>
    </d-col>
  </d-row>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { stringfy, cloneDeep } from '_utils';
import PuzzleForm from './PuzzleForm.vue';
import { MODEL, _LOAD_MODEL_ } from './PuzzleModel';

export default {
  name: 'Puzzle-form',
  components: {
    PuzzleForm,
  },
  data() {
    return {
      printType: '',
      winPrint: null,
      isGenerating: false,
    };
  },
  computed: {
    puzzle() {
      const { puzzle } = this.$store.state.puzzle;
      if (puzzle) {
        Events.$emit(_LOAD_MODEL_, puzzle);
        return puzzle;
      }
      return cloneDeep(MODEL);
    },
    hasNoQuestions() {
      return !this.puzzle.table.some(cell => cell.isQuestion);
    },
    hasAnyLetter() {
      return this.puzzle.table.some(cell => cell.text && cell.text.trim() !== '');
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'setPrintPuzzle',
      'setPrintAnswerPuzzle',
      'setPrintQuestionPuzzle',
    ]),
    print(type) {
      this.setStartedPrint(type);
      this.setPrintPuzzle(true);
      if (type === 'answers') {
        this.setPrintAnswer();
      } else {
        this.setPrintQuestion();
      }
      setTimeout(() => {
        this.openNewWindow();
      }, 500);
    },
    setStartedPrint(type) {
      let stylesHtml = '';
      const title = `<title>${stringfy(this.puzzle.name)}${
        type === 'answers' ? '-r' : ''
      }</title>`;
      // eslint-disable-next-line
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      this.winPrint = window.open(
        '',
        '',
        'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0',
      );
      this.winPrint.document.write(
        `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="utf-8">${title}<meta name="viewport" content="width=device-width,initial-scale=1.0">${stylesHtml}</head><body>`,
      );
    },
    setPrintAnswer() {
      this.setPrintAnswerPuzzle(true);
      this.setPrintQuestionPuzzle(false);
      this.$nextTick(() => {
        this.winPrint.document.write(
          document.getElementById('print').innerHTML,
        );
        this.winPrint.document.write('<div class="pagebreak"></div>');
      });
    },
    setPrintQuestion() {
      this.setPrintAnswerPuzzle(false);
      this.setPrintQuestionPuzzle(true);
      this.$nextTick(() => {
        this.winPrint.document.write(
          document.getElementById('print').innerHTML,
        );
        this.winPrint.document.write('<div class="pagebreak"></div>');
      });
    },
    openNewWindow() {
      this.winPrint.document.write('</body></html>');

      this.winPrint.document.close(); // necessary for IE >= 10
      this.winPrint.focus(); // necessary for IE >= 10*/

      this.winPrint.print();
      // WinPrint.close();
      this.setPrintAnswerPuzzle(false);
      this.setPrintQuestionPuzzle(false);
      this.setPrintPuzzle(false);
    },
    fillCrossword() {
      this.$refs.puzzleForm.generateCrosswordFromGrid();
    },
    save() {
      this.$refs.puzzleForm.handleNormalSave();
    },
    openImportModal() {
      this.setToggle({ type: 'import_file_modal', bool: true });
    },
    openSaveTemplateModal() {
      this.setToggle({ type: 'save_template_modal', bool: true });
    },
    generateNewFromCurrentTemplate() {
      this.isGenerating = true;

      this.$refs.puzzleForm.saveAndRegenerate().catch(e => {
        console.error(e);
      }).finally(() => {
        this.isGenerating = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.print-link {
  color: $primary;
  text-decoration: underline;
  cursor: pointer;
}
</style>
<style lang="scss">
@media print {
  .pagebreak {
    clear: both;
    page-break-after: always;
  }
}
</style>
